<script setup lang="ts">
import { THEME_COLOR } from "~/constants";

export interface BaseAlertProps {
  mode?: "sign-in" | "sign-up";
  fixed?: boolean;
  absolute?: boolean;
  transparent?: boolean;
}

const props = withDefaults(defineProps<BaseAlertProps>(), {
  absolute: true,
  transparent: true,
});
const { t } = useI18n();
const color = useColorMode();
const appConfig = useRuntimeConfig().public;
const defaultLocale = appConfig.APP_CUSTOMER.default_language as ILocale;
const availableLocales = appConfig.APP_CUSTOMER.available_languages_list as ILocale[];
const CUSTOMER_LOGO_URL = {
  white: appConfig.APP_CUSTOMER.appearance.logo_white_url,
  black: appConfig.APP_CUSTOMER.appearance.logo_black_url,
  default: appConfig.APP_CUSTOMER.appearance.logo_url,
};
const logo_url = computed(
  () =>
    (color.value === THEME_COLOR.DARK
      ? CUSTOMER_LOGO_URL.black
      : CUSTOMER_LOGO_URL.white)
      || CUSTOMER_LOGO_URL.default
      || "",
);
</script>

<template>
  <BaseHeader
    class="my-6"
    :logo-image-url="logo_url"
    with-locale
    :default-locale="defaultLocale"
    :transparent="props.transparent"
    :absolute="props.absolute"
    :fixed="props.fixed"
    :available-locales="availableLocales"
  >
    <template #left>
      <slot name="left" />
    </template>
    <template #append-center>
      <slot name="append-center" />
    </template>
    <template #append-end>
      <template v-if="props.mode === 'sign-up'">
        <AuthButton
          class="flex-shrink-0 font-medium"
          outline
          mode="sign-up"
          :title="t('labels.sign_up')"
        />
      </template>
      <template v-else-if="props.mode === 'sign-in'">
        <AuthButton
          class="flex-shrink-0 font-medium"
          outline
          mode="sign-in"
          :title="t('labels.sign_in')"
        />
      </template>
      <template v-else>
        <slot name="append-end" />
      </template>
    </template>
  </BaseHeader>
</template>
